import React, { useEffect } from 'react';
import { Alert, Button } from "flowbite-react";
import { IoWarningOutline } from "react-icons/io5";
import { HiEye } from "react-icons/hi2";
import { Config } from "../../app.config";
import Options from "../components/Options";
import SearchForm from "../components/SearchForm";
import Results from "../components/Results";
import Facets from "../components/Facets";
export default function Home() {
  if (Config.disableSearch) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container mx-auto text-gray-700 w-full md:w-3/4 lg:w-2/3 xl:w-1/2 dark:text-gray-100 p-4 md:p-8 lg:p-12"
    }, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Alert, {
      color: "warning",
      icon: IoWarningOutline,
      additionalContent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "mb-4 text-sm"
      }, /*#__PURE__*/React.createElement("p", null, "Due to Pushshift being cut off from the Reddit API, they have shut off their own API. The only communication at this point from Pushshift is \"Check back in the next few weeks for updates.\""), /*#__PURE__*/React.createElement("p", {
        className: "mt-2"
      }, "So until further notice, Churning Search is unavailable. Once Pushshift determines/announces their path forward, it will be decided how Churning Search will proceed. All announcements regarding Churning Search will be posted in the Daily Discussion thread and here."), /*#__PURE__*/React.createElement("p", {
        className: "mt-2"
      }, /*#__PURE__*/React.createElement("strong", {
        className: "font-medium"
      }, "Search Help:"), " ", /*#__PURE__*/React.createElement("a", {
        className: "underline underline-offset-3",
        href: "https://www.google.com/search?q=site%3Areddit.com%2Fr%2Fchurning+intitle%3A%22question+thread%22"
      }, "Try a google search including the following:")), /*#__PURE__*/React.createElement("div", {
        className: "mt-4 text-center"
      }, /*#__PURE__*/React.createElement("code", null, "site:reddit.com/r/churning intitle:\"question thread\""))), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-wrap items-center gap-2"
      }, /*#__PURE__*/React.createElement(Button, {
        color: "warning",
        href: "https://reddit.com/r/churning/comments/13lpwno/daily_discussion_thread_may_19_2023/jkvb7fs/?context=3",
        target: "_blank",
        size: "xs",
        pill: true
      }, /*#__PURE__*/React.createElement(HiEye, {
        className: "-ml-0.5 mr-2 h-4 w-4"
      }), " More info"))),
      rounded: true
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-lg md:text-xl lg:text-2xl font-medium font-mono tracking-tighter"
    }, "Churning Search Unavailable"))));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "lg:h-dvh lg:min-h-dvh lg:flex text-gray-700 dark:text-gray-100"
    }, /*#__PURE__*/React.createElement("div", {
      id: "search-form-panel",
      className: "md:flex lg:block lg:w-2/5 xl:w-1/3 2xl:w-1/4 p-4 overflow-y-scroll bg-blue-200 dark:bg-slate-900 border-r border-gray-200 dark:border-gray-700 shadow-lg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "md:w-1/2 lg:w-full md:pr-4 lg:pr-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "text-2xl text-gray-700 dark:text-gray-100 font-mono tracking-tighter"
    }, Config.name), /*#__PURE__*/React.createElement(Options, null)), /*#__PURE__*/React.createElement(SearchForm, null)), /*#__PURE__*/React.createElement(Facets, null)), /*#__PURE__*/React.createElement("div", {
      id: "results-panel",
      className: "mt-8 lg:mt-0 flex flex-1 flex-col bg-white dark:bg-slate-900 overflow-y-scroll"
    }, /*#__PURE__*/React.createElement(Results, null)));
  }
}